import React from 'react'
import ReactDOM from 'react-dom/client'
import { HelmetProvider } from 'react-helmet-async'
import '@/index.css'

import('@/App.jsx').then(({ default: App }) => {
  ReactDOM.createRoot(document.getElementById('root')).render(
    <HelmetProvider>
      <App />
    </HelmetProvider>
  )
}).catch((err) => {
  throw err
})
